import React from 'react';
import { StyledInput } from '../Styled';

interface IInput {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Input: React.FC<IInput> = (props): JSX.Element => {
  const { value, onChange } = props;

  return <StyledInput data-testid="input" type="text" value={value} onChange={onChange} />;
};
